var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9413 13.9935L6.77379 26.1611C6.35315 26.5818 6.35315 27.2639 6.77379 27.6846C7.19456 28.1051 7.87657 28.1051 8.29728 27.6846L21.2266 14.7553C21.6471 14.3346 21.6471 13.6525 21.2266 13.2318L8.29728 0.302494C7.86925 -0.110889 7.18718 -0.09902 6.77379 0.32901C6.37057 0.746561 6.37057 1.40849 6.77379 1.82598L18.9413 13.9935Z",
    fill: "#00683A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c96f4896.svg";
export { ForwardRef as ReactComponent };